import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full p-2 mt-0 font-extrabold text-white no-underline bg-gray-500 border-b-2 border-black tex-xxl bg-opacity-30 hover:no-underline" }
const _hoisted_2 = { class: "container flex flex-wrap items-center mx-auto" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "flex justify-center w-full md:w-1/2 md:justify-start" }, [
  /*#__PURE__*/_createVNode("a", {
    class: "hover:text-purple-200 ",
    href: "#"
  }, [
    /*#__PURE__*/_createVNode("span", { class: "pl-2 text-2xl" }, [
      /*#__PURE__*/_createVNode("i", { class: "em em-grinning" }),
      /*#__PURE__*/_createTextVNode("Laurie Hanson Books")
    ])
  ])
], -1)
const _hoisted_4 = { class: "flex content-center justify-between w-full pt-2 md:w-1/2 md:justify-end" }
const _hoisted_5 = { class: "flex items-center justify-between flex-1 list-reset md:flex-none" }
const _hoisted_6 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("nav", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode("ul", _hoisted_5, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.routes, (route, index) => {
            return (_openBlock(), _createBlock("li", {
              key: route.to,
              class: "mr-3 text-2xl hover:text-purple-200"
            }, [
              _createVNode(_component_router_link, {
                to: route.to
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(route.label), 1)
                ]),
                _: 2
              }, 1032, ["to"]),
              (index !== _ctx.routes.length - 1)
                ? (_openBlock(), _createBlock("span", _hoisted_6, " | "))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}